import React from 'react';
import classNames from 'classnames';
import { Icon } from '@beisen/chaos-ui';
import ApprovalOpt from './ApprovalOpt';
import ApprovalAvatar from './ApprovalAvatar';
require('./ItemCard.scss');
/*
cardInfo['maiTitle'] = itemInfo.assignesNames;
        cardInfo['subTitle'] = itemInfo.name;
        cardInfo['avatar'] = itemInfo.assignes[0];
        cardInfo['rightTag'] = itemInfo.assignes[0].option;
        {
            "maiTitle": 'anxuenan,sss',
            "subTitle": '第一审批人',
            "avatar": {
                    "id": 107460817,
                    "name": "anxuenan",
                    "headPortrait": "",
                    "color": "#f79c6f",
                    "approvalState": 1,
                    "TaskCompleteTime": '43/343',
                    "actionName": '同意',
                    "comment": 'dfsdfsdfsdfdsfsdfsdfsdfsdfsdfsdfsdfsdfsdfsdfsdfsdfsdfsfsdfsdfsdfsdfsdfsd'
            },
            "hasAvatar": true,
            "status": 3,
            "rightTag": '同意',
            "botContent": 'dfsdfsdfsdfdsfsdfsdfsdfsdfsdfsdfsdfsdfsdfsdfsdfsdfsdfsfsdfsdfsdfsdfsdfsd',
            "assignesNum": 4
        }

*/
class ItemCard extends React.Component {

	constructor(props) {
		super(props);
        this.multiple = props.info && props.info.assignesNum > 1;
    }

    componentDidMount() {
        const text = this.refs.mainItem;
        if(text && !this.multiple) {
            const textWidth = text.offsetWidth;
            const containerWidth = this.refs.lineContainer.offsetWidth;
            if(textWidth > containerWidth) {
                text.style.width = '100%';
            }
        }
    }

    renderFlexText(item) {
        const mainItem = item.mainItem;
        const subItem = item.subItem;
        return (<div className={item.cls} ref="lineContainer" >
                    <span className="sub-item text-ellipsis">{subItem}</span>
                    <span className="space-item" />  {/*需优化*/}
                    <span className="main-item" ref="mainItem">{mainItem}</span>
               </div>);
    }
// 活动节点 activityType == 3 只显示一个人
    renderApprovalName() {
        const { info, translation } = this.props;
        const assignesCount = info.assignesCount;
        const hasAvatars = info.hasAvatar;
        const activity = info.activityType == 3;
        const { num } = translation;
        const tag = num.replace('$count', assignesCount);
        const itemOpt = { cls: 'approval-item-assignesNames'
                            ,subItem: info.maiTitle
                            ,mainItem: this.multiple ?  (activity ? null : tag) : info.rightTag };
        return (<div className={classNames('approval-item-names', 'n-' + info.status,{ 'only': hasAvatars ? false : true })}>
                    {info.maiTitle ? this.renderFlexText(itemOpt) : null}
                    <div className="approval-item-name text-ellipsis">{info.subTitle}</div>
                </div>
        );
    }

	render() {
        const { info, handleTap, cls, style, translation } = this.props;
        if(!info) {
            return null;
        }
        return (<div className={classNames(cls,'approval-item-card',{ 'item-end': info.isEnd, 'item-multiple': this.multiple },'item-card-status-' + info.status)} style={style} onTouchTap={handleTap}>
                        <ApprovalAvatar info={info} />
                        {this.renderApprovalName()}
                        {this.multiple ? <Icon className='multiple-arrow' icon="m-sys-forward" /> : null}
                        {(info.botContent && (info.botContent.length > 0) && info.assignesNum == 1) ? <ApprovalOpt translation={translation} text={info.botContent} setLine={this.props.setLine} /> : null}
                </div>);
    }
}

export default ItemCard;



// WEBPACK FOOTER //
// ./src/components/Approval/new/ItemCard.js